import { WBTypography } from '@admiin-com/ds-web';
import { WBListItemText } from '@admiin-com/ds-web';
import { WBS3Avatar } from '@admiin-com/ds-amplify-web';
import { WBFlex } from '@admiin-com/ds-web';
import { useMemo } from 'react';
import { truncateText } from '../../../../../../../../helpers/string';
export const EntityItem = ({
  entity,
  onClick,
  hideAbn = false,
  nameLimit = 30,
  color = 'light',
}: {
  entity: any;
  onClick?: () => void;
  hideAbn?: boolean;
  nameLimit?: number;
  color?: string;
}) => {
  const subTitle = useMemo(() => {
    return (
      entity?.taxNumber ??
      entity?.companyNumber ??
      entity?.entity?.taxNumber ??
      entity?.entity?.companyNumber ??
      ''
    );
  }, [entity]);
  return (
    <WBFlex alignItems={'center'} gap={[1, 2]} onClick={onClick}>
      <WBS3Avatar
        sx={{
          borderRadius: '50%',
          width: { xs: '30px', md: '30px' },
          height: { xs: '30px', md: '30px' },
        }}
        imgKey={entity.logo?.key}
        fontSize="h4.fontSize"
        identityId={entity.logo?.identityId}
        level={entity.logo?.level}
        companyName={entity.name}
      />
      <WBListItemText
        primary={
          <WBTypography color={color} noWrap>
            {truncateText(entity.name, nameLimit)}
          </WBTypography>
        }
        secondary={
          subTitle &&
          !hideAbn && (
            <WBTypography variant="body2" color="textSecondary" noWrap>
              {subTitle}
            </WBTypography>
          )
        }
      />
    </WBFlex>
  );
};
